import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { RolesApiService } from '@angular-workspace/services';
import { ToasterService } from '../../../services/toaster.service';
import { LoginModalService } from '../../../services/login-modal.service';
import { hasRecognizedMahaPanelRole } from '../../../utils/maha-panel-access.util';

/**
 * Component that redirects users to their highest role panel
 * Used for panel root routes (e.g., /consumer, /provider, /org-admin, /admin)
 */
@Component({
  selector: 'app-role-redirect',
  standalone: true,
  template: '<div>Redirecting...</div>',
})
export class RoleRedirectComponent implements OnInit {
  private router = inject(Router);
  private keycloak = inject(KeycloakService);
  private rolesService = inject(RolesApiService);
  private toasterService = inject(ToasterService);
  private loginModal = inject(LoginModalService);

  async ngOnInit(): Promise<void> {
    try {
      const isLoggedIn = await this.keycloak.isLoggedIn();

      if (!isLoggedIn) {
        this.loginModal.open(window.location.pathname + window.location.search);
        return;
      }

      this.loginModal.close();

      try {
        await this.rolesService.getRoles();
        const userRoles = this.rolesService.getUserRoles();

        if (hasRecognizedMahaPanelRole(this.rolesService)) {
          const highestRolePanelRoute = this.rolesService.getHighestRolePanelRoute(userRoles);
          this.router.navigate([highestRolePanelRoute], { replaceUrl: true });
          return;
        }

        if (userRoles && userRoles.length > 0) {
          const highestRolePanelRoute = this.rolesService.getHighestRolePanelRoute(userRoles);
          this.router.navigate([highestRolePanelRoute], { replaceUrl: true });
          return;
        }
      } catch (error) {
        console.error('Error fetching roles for redirect:', error);
      }

      this.toasterService.warning("You don't have access to some of the panels.");
      this.router.navigate(['/'], { replaceUrl: true });
    } catch (error) {
      console.error('Error in role redirect component:', error);
      this.toasterService.warning("You don't have access to some of the panels.");
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }
}

